<template>
    <div class="supplier-verification-reply-row border-top py-1">
        <div class="mb-50">
            <SupplierVerificationSourceBadge source="reply" />
        </div>
        <div class="d-flex align-items-center justify-content-between">
            <div>{{ fileName }}</div>
            <div>
                <b-button
                    variant="primary"
                    class="btn-icon btn-sm mr-50"
                    @click="$emit('download', document)"
                >
                    <feather-icon icon="DownloadCloudIcon" />
                </b-button>
                <b-button
                    variant="primary"
                    class="btn-icon btn-sm"
                    @click="$emit('preview', document)"
                >
                    <feather-icon icon="EyeIcon" />
                </b-button>
            </div>
        </div>
        <div
            v-if="legislations.length"
            class="mt-50"
        >
            <div class="text-less-muted">{{ $t('Component(Verification):legislations-covered') }}</div>
            <div class="mt-25">
                <b-badge
                    v-for="legislation in legislations"
                    :key="legislation.id"
                    variant="light-primary"
                    class="mr-50"
                >
                    {{ legislation.title }}
                </b-badge>
            </div>
        </div>
        <div
            v-if="documentTypes.length"
            class="mt-50"
        >
            <div class="text-less-muted">{{ $t('Component(Verification):type-of-document') }}</div>
            <div class="mt-25">
                <b-badge
                    v-for="type in documentTypes"
                    :key="type.id"
                    variant="light-secondary"
                    class="mr-50"
                >
                    {{ type.title }}
                </b-badge>
            </div>
        </div>
        <div
            v-if="document.declarationDate || document.declarationValidityDate"
            class="d-flex flex-wrap mt-50"
        >
            <div
                v-if="document.declarationDate"
                class="mr-2"
            >
                <div class="text-less-muted">{{ $t('Component(Verification):declaration-date') }}</div>
                <div>{{ document.declarationDate }}</div>
            </div>
            <div
                v-if="document.declarationValidityDate"
                class="mr-2"
            >
                <div class="text-less-muted">{{ $t('Component(Verification):validity-of-declaration') }}</div>
                <div>{{ document.declarationValidityDate }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { BBadge, BButton } from 'bootstrap-vue'
import SupplierVerificationSourceBadge from './SupplierVerificationSourceBadge.vue'

export default {
    components: { BBadge, BButton, SupplierVerificationSourceBadge },
    props: {
        document: {
            type: Object,
            required: true,
        },
    },
    computed: {
        fileName() {
            return this.document.file && this.document.file.name ? this.document.file.name : ''
        },
        legislations() {
            return Array.isArray(this.document.legislations) ? this.document.legislations : []
        },
        documentTypes() {
            return Array.isArray(this.document.documentTypes) ? this.document.documentTypes : []
        },
    },
}
</script>
